export default {
  id: 'problemDescription/SYMPTOMS_BY_PATIENT/v1',
  formSchema: {
    title: 'encounter:widget.problemDescription.symptomsByPatient',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.problemDescription.symptomsByPatient',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
